import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "animate-pulse" }
const _hoisted_2 = {
  key: 2,
  class: "rounded-md overflow-hidden border shadow-md bg-white dark:bg-gray-800 dark:border-gray-700"
}
const _hoisted_3 = { class: "p-4 py-2" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"p-4 pt-6\"><div class=\"h-6 bg-gray-300 dark:bg-gray-700 rounded mb-4 w-3/4\"></div><div class=\"space-y-2 mb-4\"><div class=\"h-4 bg-gray-300 dark:bg-gray-700 rounded w-full\"></div><div class=\"h-4 bg-gray-300 dark:bg-gray-700 rounded w-5/6\"></div><div class=\"h-4 bg-gray-300 dark:bg-gray-700 rounded w-4/6\"></div></div><div class=\"h-4 bg-gray-300 dark:bg-gray-700 rounded w-2/3\"></div></div>", 1)


export default /*#__PURE__*/_defineComponent({
  __name: 'SkeletonLoader',
  props: {
    type: { default: 'text' },
    imageClass: { default: '' },
    textClass: { default: '' },
    cardImageClass: { default: '' },
    customClass: { default: '' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type === 'image')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'bg-gray-300 dark:bg-gray-700 rounded',
        _ctx.imageClass || 'w-full h-64'
      ])
        }, null, 2))
      : (_ctx.type === 'text')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
        'bg-gray-300 dark:bg-gray-700 rounded',
        _ctx.textClass || 'h-4'
      ])
          }, null, 2))
        : (_ctx.type === 'card')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass([
            'bg-gray-300 dark:bg-gray-700 rounded-t-md',
            _ctx.cardImageClass || 'w-full h-80'
          ])
                }, null, 2)
              ]),
              _hoisted_4
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(_ctx.customClass)
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 2))
  ]))
}
}

})